import React, { useMemo, useState, useRef, useEffect } from "react";
import { Button, Checkbox, Icon, Input, Select, Spin, Tooltip } from "antd";
import { debounce } from "lodash";
import CustomModal from "../../../../Common-Modal/CustomModal";
import CustomAgGridTable from "../../../../Common-Table/CustomAgGridTable";
import CheckBoxRenderer from "../CheckBoxRenderer";
import { Translate } from "react-translated";
import axios from "axios";
import F, { getPopupContainer } from "../../../../Functions";
import "../CheckBoxRenderer.css";
import { CarrierList, IN, INACTIVE_AGENCY, REVIEWSCHEDULER, TA, TEST_AGENCY, VONSCHEDULER } from "../../../../utils/Constants";
import CustomHeader from "../../../../CommonHeader/CustomHeader";
import DownArrowIcon from "../../../../scenes/LandingPage/images/new/down-arrow.png";
import TypeOfCallRenderer from "../../../../Custom-Tooltip/TypeOfCallRenderer";
import { GET_FS_ALL_AGENCIES, GET_RFS_ALL_AGENCIES, RS_ALL_AGENCIES_API_URL } from "../../../../utils/Api_enums";
import AgencyBadge from "../../../../Custom-Tooltip/AgencyBadge";


const { Search } = Input;
const { Option } = Select;
const ActivatedAgencyModal = (props) => {
  const gridApiRef = useRef(null); // Reference to the grid API
  // console.log("props modal",props)
  const {
    isVisible,
    closeModal,
    agency_type_map,
    title,
    user,
    agencies,
    user_agencies,
    setActivatedSchedulerState,
    updateAgencyAssoc,
    activatedSchedulerState,
    userRoles
  } = props;

  const [searchTerm, setSearchTerm] = useState("");
  const [carrierFilter, setCarrierFilter] = useState(undefined);
  const [stateFilter, setStateFilter] = useState(undefined);
  const [stateList, setStateList] = useState([]);
  const [carrierDropdownOpen, setCarrierDropdownOpen] = useState(false);
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const carrierWrapperRef = useRef(null);
  const stateWrapperRef = useRef(null);
  const [modifiedData, setModifiedData] = useState([]);
  const [columnDefs, setColumnDefs] = useState([]);
  const [sortOrders, setSortOrders] = useState({});
  const [localField, setLocalField] = useState("updated_on");
  const [localOrder, setLocalOrder] = useState("desc");
  const [gridApi, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridApiOptions, setGridApiOptions] = useState({
    api: null,
    columnApi: null,
  });

  const filterCallTypes = (agency, userRoles) => {
    let types = userRoles ? [...userRoles] : [];

    types = userRoles;

    // if (agency.review && agency.vonboard) {
    //   types = types.filter((t) => ["Review", "Prospect", "FollowUp"].includes(t));
    // } else if (!agency.review && agency.vonboard) {
    //   types = types.filter((t) => t !== "Review");
    // } else if (agency.review && !agency.vonboard) {
    //   types = types.filter((t) => t === "Review");
    // }

    return types;
  }

  useEffect(() => {
    if (user) {
      getAgenciesList();
    }
  }, [user, user_agencies]);


  const getAgenciesList = async () => {
    try {

      const apiUrl =
        user.user_type === VONSCHEDULER
          ? GET_RFS_ALL_AGENCIES
          : user.user_type === REVIEWSCHEDULER
            ? RS_ALL_AGENCIES_API_URL
            : GET_FS_ALL_AGENCIES;

      const res = await axios.get(apiUrl);

      const agenciesData = Array.isArray(res.data) ? res.data : res.data.agencies || [];


      const updatedAgencies = agenciesData.map((agency) => {
        let isChecked;
        let type_of_call_checked
        if (user_agencies.length > 0) {
          isChecked = Array.isArray(user_agencies) && user_agencies.includes(agency.id);
          type_of_call_checked = agency_type_map && agency_type_map[agency.id] || {};
        }
        return {
          ...agency,
          agency_owner: `${agency.agency_owner_first_name || ""} ${agency.agency_owner_last_name || ""}`.trim(),
          type_of_call: filterCallTypes(agency, userRoles),
          name: agency.name,
          state: agency.agency_owner_state,
          carrier: agency.agency_owner_carrier,
          isChecked,
          userType: user.user_type,
          type_of_call_checked
        };
      });


      updatedAgencies.sort((a, b) => b.isChecked - a.isChecked);

      // console.log("✅ Checked Agencies:", updatedAgencies.filter(a => a.isChecked));

      setActivatedSchedulerState((prev) => ({
        ...prev,
        agencies: updatedAgencies,
        agencies_modal_loading: false,
      }));

      // Update grid data
      setModifiedData(updatedAgencies);
    } catch (error) {
      console.error("Error fetching agencies:", error);
    }
  };




  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (carrierWrapperRef.current && !carrierWrapperRef.current.contains(event.target)) {
  //       setCarrierDropdownOpen(false);
  //     }
  //     if (stateWrapperRef.current && !stateWrapperRef.current.contains(event.target)) {
  //       setStateDropdownOpen(false);
  //     }
  //   };
  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => document.removeEventListener("mousedown", handleClickOutside);
  // }, []);



  const getCountryDropDown = async () => {
    try {
      const {
        data: { states },
      } = await axios.get("/api/google_maps/list_states_in_usa");
      // console.log("states", states);
      setStateList(states);
    } catch (error) {
      console.log("error", error);
      console.log("Something went wrong");
    }
  };

  useEffect(() => {
    getCountryDropDown();
  }, []);

  const handleChange = (updatedData) => {
    let data = updatedData.data;
    data.type_of_call_checked = data.type_selected;
    updateAgencyAssoc(data, data.isChecked, data);
  };



  const handleButtonClick = (data, checked, setIsChecked) => {

    const type_of_call_checked = Object.fromEntries(data.type_of_call.map(type => [type, checked]));


    const updatedRow = {
      ...data,
      isChecked: checked,
      type_of_call_checked
    };



    gridApiRef.current.api.applyTransaction({
      update: [updatedRow], // The updated row is in an array
    });


    updateAgencyAssoc(data, checked, updatedRow);
  };

  const updateData = (id, checked) => {
    const updatedDataArr = agencies.map((row) =>
      row.id === id ? { ...row, isChecked: checked } : row
    );

    setActivatedSchedulerState((prevState) => ({
      ...prevState,
      agencies: updatedDataArr,
    }));
    //  update state here of data
  };




  const CustomTooltip = (props) => {
    return (
      <div style={{
        background: "rgba(0, 0, 0, 0.8)",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        maxWidth: "200px",
        textAlign: "center"
      }}>
        {props.value}
      </div>
    );
  };



  useEffect(() => {
    if (modifiedData.length > 0) {
      // console.log("🟩 Modified Data Updated:", modifiedData);
      setColumnDefs(getColumns())
    }
  }, [modifiedData, sortOrders]);



  const sortByField = (field, order) => {
    setModifiedData(prev => {
      const sorted = [...prev].sort((a, b) => {

        if (a.isChecked && !b.isChecked) return -1;
        if (!a.isChecked && b.isChecked) return 1;

        const aVal = (a[field] || "").toString().toLowerCase();
        const bVal = (b[field] || "").toString().toLowerCase();
        if (order === "asc") return aVal.localeCompare(bVal);
        else return bVal.localeCompare(aVal);
      });
      return sorted;
    });
  };



  const handleSort = (field) => {
    let newOrder;
    setSortOrders(prev => {
      const currentOrder = prev[field] || "asc";
      newOrder = currentOrder === "asc" ? "desc" : "asc";
      return { ...prev, [field]: newOrder };
    });

    sortByField(field, newOrder);
    setLocalField(field);
    setLocalOrder(newOrder);
  }


  const CreateAgencyNameRenderer = React.forwardRef((params, ref) => {
    const agency = params.data;
    return (
      <div ref={ref}>
        <span>
          {agency.name}
          <AgencyBadge
            showTest={agency.test == 1}
            showInactive={agency.active == 0}
          />
        </span>
      </div>
    );
  });


  const getColumns = () => {
    return [
      {
        headerName: "",
        cellRendererFramework: CheckBoxRenderer,
        width: 50,
        filter: false,
        sortable: false,
        cellRendererParams: {
          onButtonClick: (data, checked, setIsChecked, rowNode) =>
            handleButtonClick(data, checked, setIsChecked, rowNode),  // NOSONAR
          user_agencies,
          updateData,
        },
      },
      {
        headerClass: 'custom-ag-header', // NOSONAR
        headerName: "Agency Owner", // NOSONAR
        valueGetter: (params) => `${params.data.agency_owner || ""}`, // NOSONAR
        sortable: true, // NOSONAR
        // filter: true,
        sortOrder: sortOrders["agency_owner"], // NOSONAR
        // handleSort,
        headerComponentParams: (params) => ({ // NOSONAR
          headers: ["Agency Owner"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "agency_owner",
          sortOrder: sortOrders["agency_owner"],
          handleSort
        }),
        // colId: 'agency_owner', // NOSONAR
        headerComponent: CustomHeader, // NOSONAR
        tooltipComponent: CustomTooltip, // NOSONAR
      },
      {
        width: 300,
        headerClass: 'custom-ag-header',
        headerName: "Agency Name",
        // valueGetter: (params) => `${params.data.name || ""}`,
        cellRenderer: 'CreateAgencyNameRenderer',
        sortable: true,
        sortOrder: sortOrders["name"],
        headerComponentParams: (params) => ({
          headers: ["Agency"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "name",
          sortOrder: sortOrders["name"],
          handleSort,
        }),
        colId: 'name',
        headerComponent: CustomHeader,
        tooltipComponent: CustomTooltip,
      },





      //Type of Call
      {
        width: 400,
        headerComponentParams: (params) => ({
          headers: ["Type Of Call"]
        }),
        headerName: 'Type Of Call',
        headerClass: 'custom-ag-header',
        headerComponent: CustomHeader,
        cellRendererFramework: TypeOfCallRenderer,
        cellRendererParams: (params) => ({
          onChange: () => handleChange(params)
        })

      },

      {
        // headerName: "State",
        // field: "state",
        // sortable: true,
        // filter: true,
        width: 200,
        headerClass: 'custom-ag-header',
        headerName: "State",
        valueGetter: (params) => `${params.data.state || ""}`,
        sortable: true,
        // filter: true,
        sortOrder: sortOrders["state"],
        // handleSort,
        headerComponentParams: (params) => ({
          headers: ["State"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "state",
          sortOrder: sortOrders["state"],
          handleSort
        }),
        colId: 'state',
        headerComponent: CustomHeader,
        tooltipComponent: CustomTooltip,
      },
      {
        // headerName: "Carrier",
        // field: "carrier",
        // sortable: true,
        // filter: true,
        headerClass: 'custom-ag-header',
        // headerName: "Carrier",
        // field: "carrier",
        // sortable: true,
        // filter: true,
        headerClass: 'custom-ag-header', // NOSONAR
        headerName: "Carrier",
        valueGetter: (params) => `${params.data.carrier || ""}`, // NOSONAR
        valueGetter: (params) => `${params.data.carrier || ""}`,// NOSONAR
        sortable: true,
        // filter: true,
        sortOrder: sortOrders["carrier"], // NOSONAR
        // handleSort,
        headerComponentParams: (params) => ({
          headers: ["Carrier"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "carrier",
          sortOrder: sortOrders["carrier"],
          handleSort
        }),
        colId: 'carrier',
        headerComponent: CustomHeader,
        tooltipComponent: CustomTooltip,
        // filter: true,
        sortOrder: sortOrders["carrier"], // NOSONAR
        // handleSort,
        headerComponentParams: (params) => ({ // NOSONAR
          headers: ["Carrier"],
          colDef: params.column.getColDef(),
          columnApi: params.columnApi,
          field: "carrier",
          sortOrder: sortOrders["carrier"],
          handleSort
        }),
        colId: 'carrier', // NOSONAR
        headerComponent: CustomHeader, // NOSONAR
        tooltipComponent: CustomTooltip, // NOSONAR
      },
    ];
  }


  const handleSearchChange = (e) => {
    // debouncedSearch(e.target.value);
    setSearchTerm(e.target.value)
  };

  const handleCarrierChange = (value) => {
    // console.log("carier values==> ", value);
    setCarrierFilter(value);
  };

  const handleStateChange = (value) => {
    // console.log("value", value);
    setStateFilter(value);
  };

  const applyFilters = (agency) => {
    if (!agency) return false;

    // Convert search term to lowercase once
    const lowerSearchTerm = searchTerm && searchTerm.toLowerCase();

    // Search filter
    if (
      lowerSearchTerm &&
      !(
        (agency.name && agency.name.toLowerCase().includes(lowerSearchTerm)) ||
        (agency.agency_owner && agency.agency_owner.toLowerCase().includes(lowerSearchTerm))
      )
    ) {
      return false;
    }

    // Carrier filter (now supports multiple values)
    if (
      Array.isArray(carrierFilter) &&
      carrierFilter.length > 0 &&
      !carrierFilter.some(
        (carrier) => agency.carrier && carrier.toLowerCase() === agency.carrier.toLowerCase()
      )
    ) {
      return false;
    }

    // State filter (now supports multiple values)
    if (
      Array.isArray(stateFilter) &&
      stateFilter.length > 0 &&
      !stateFilter.some(
        (state) => agency.state && state.toLowerCase() === agency.state.toLowerCase()
      )
    ) {
      return false;
    }

    return true;
  };



  const handleSelectionChanged = () => {
    if (gridApiRef.current) {
      // TODO: Handle selection changes here
      const selectedRowsData = gridApiRef.current.api.getSelectedNodes(); // Get selected rows from the grid
      const selectedIds = selectedRowsData.map((row) => row.data.id); // New Set with just row IDs
    }
  };

  // Apply filters to the data
  const filteredData = useMemo(() => {
    return modifiedData.filter(applyFilters);
  }, [modifiedData, searchTerm, carrierFilter, stateFilter]);

  const gridOptions = {
    getRowStyle: (params) => {
      if (params.node.isSelected()) {
        return { backgroundColor: "transparent" }; // Remove selected row background
      }
      return null;
    },
    onGridReady: (params) => {
      gridApiRef.current = params.api; // Assign the grid API to the ref when the grid is ready
    },
  };


  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    let excludedCols = ['checkbox'];
    F.handleGridReady(params, setGridApiOptions, excludedCols);
    gridApiRef.current = params;
    setTimeout(() => {
      params.api.forEachNode((node) => {
        if (user_agencies.indexOf(node.data.id) >= 0) {
          node.setSelected(true);
        }
      });
    }, 100);
  };


  const refreshTableData = () => {
    setSearchTerm("")
    setSearchTerm(undefined);
    setCarrierFilter(undefined);
    setStateFilter(undefined);
  }

  return (
    <CustomModal
      isVisible={isVisible}
      setIsVisible={closeModal}
      title={title}
      width={"85%"}
      footer={
        <div>
          <Button
            className="borderRadius-28"
            onClick={() => {
              closeModal && closeModal();
            }}
          >
            <Translate text={`Cancel`} />
          </Button>
        </div>
      }
    >
      <div className="">
        <div className="agencies-filters">
          <div>
            <Input
              placeholder="Search by Name"
              suffix={
                searchTerm ? (
                  <Icon
                    type="close"
                    onClick={() => setSearchTerm("")}
                    className="icon-style"
                    style={{ right: '0px' }}
                  />
                ) : (
                  <Icon
                    type="search"
                    className="icon-style"
                    style={{ right: '0px' }}
                  />
                )
              }

              onChange={handleSearchChange}
              // style={{ width: 300 }}
              className="searchinput agency-multiselect "
              value={searchTerm}
            />
          </div>
          <div >
            <span ref={carrierWrapperRef}
              className="drop-down-select-ui width-100"
            >

              <Select
                open={carrierDropdownOpen}
                onDropdownVisibleChange={(open) => setCarrierDropdownOpen(open)}
                placeholder="Select Carrier "
                // onChange={(value) => console.log(value)}
                onChange={handleCarrierChange}
                value={carrierFilter}
                // allowClear={true}
                mode="multiple"
                maxTagCount={1}
                style={{
                  // width: 300,
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  // border: "1px solid #cfc9c9",
                }}
                className="agency-multiselect-dropdown agency-multiselect "
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {CarrierList.map((carrier) => (
                  <Option key={carrier.id} value={carrier.name}>
                    {carrier.name}
                  </Option>
                ))}
              </Select>
              <Icon
                type={carrierDropdownOpen ? "up" : "down"}
                className="icon-style right-15"
                onClick={() => setCarrierDropdownOpen((prev) => !prev)}
              />
            </span>
            <span ref={stateWrapperRef}
              className="drop-down-select-ui width-100"

            >

              <Select
                open={stateDropdownOpen}
                onDropdownVisibleChange={(open) => setStateDropdownOpen(open)}
                placeholder="Select State "
                onChange={handleStateChange}
                // allowClear={true}
                mode="multiple"
                maxTagCount={1}
                value={stateFilter}
                // onChange={(value) => console.log(value)}
                style={{
                  // width: 300,
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  // border: "1px solid #cfc9c9",
                }}
                className="agency-multiselect-dropdown agency-multiselect "
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {stateList.map((state) => (
                  <Option key={state} value={state}>
                    {state}
                  </Option>
                ))}
              </Select>
              <Icon
                type={stateDropdownOpen ? "up" : "down"}
                className="icon-style right-15"
                onClick={() => setStateDropdownOpen((prev) => !prev)}
              />
            </span>
            <Button

              type='primary'
              className='refresh-con agency-filter-btn'
              onClick={refreshTableData}
            >
              <Icon type="reload" />
            </Button>
          </div>
        </div>
        <div>
          <Spin
            spinning={
              activatedSchedulerState.loading ||
              activatedSchedulerState.agencies_modal_loading
            }
          >
            {columnDefs.length > 0 ? (
              <CustomAgGridTable
                rowDatas={filteredData}
                columnDefss={columnDefs}
                gridApiOptions={{
                  rowSelection: "multiple",
                  ...gridOptions,
                  getRowId: (params) => params.data.id,
                  onSelectionChanged: handleSelectionChanged,
                  suppressRowClickSelection: true,
                  onGridReady: onGridReady,
                }}
                frameworkComponents={{
                  CreateAgencyNameRenderer
                }}
                styles={{ height: "380px", minHeight: "350px" }}
              />
            ) : null
            }
            {(activatedSchedulerState.loading ||
              activatedSchedulerState.agencies_modal_loading) && (
                <div style={{
                  position: 'absolute',
                  top: 0, left: 0, right: 0, bottom: 0,
                  background: 'rgba(255,255,255,0.6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10
                }}>
                  <Spin tip="Loading ..." />
                </div>
              )}
          </Spin>
        </div>
      </div>
    </CustomModal>
  );
};

export default ActivatedAgencyModal;



// WEBPACK FOOTER //
// ./src/scenes/SuperAdmin/Modals/ActivatedAgencyModal/ActivatedAgencyModal.js